export default "__VITE_PUBLIC_ASSET__f6eabb31__"